module.exports = __webpack_public_path__ + "img/game-banner-image-new.f768c8a8.png";